const theme = {
  DARK: {
    primary: '#3995F5',
    accent: '#F36834',
    color1: '#2A2A2A',
    color2: '#999999',
    color3: '#f3f3f3',
    hover: '#B3E5FC',
    border: '#e6e6e6',
    bg: '#fff',
    color4: '#333333',
    code: '#f3f3f3',
  },
  LIGHT: {
    primary: '#3995F5',
    accent: '#F36834',
    color1: '#2A2A2A',
    color2: '#999999',
    color3: '#f3f3f3',
    color4: '#333333',
    hover: '#B3E5FC',
    border: '#e6e6e6',
    bg: '#fff',
    code: '#f3f3f3',
  }
}

const ThemeType = {
  DARK: 'DARK',
  LIGHT: 'LIGHT',
}

// 将样式变为全局css
function writeNewStyle(theme) {
  const oldStyle = document.querySelector('.--app-theme-class')
  if (oldStyle) {
    oldStyle.parentNode.removeChild(oldStyle)
  }

  const cssText = Object.keys(theme).reduce((prevs, key) => prevs += `--${key}: ${theme[key]}; `, ``)
  const style = document.createElement('style')
  style.setAttribute('class', '--app-theme-class')
  style.innerText = `:root{ ${cssText} }`
  document.head.appendChild(style)
}

// 检测用户手机是否开启暗黑模式
function isDarkTheme() {
  return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
}

export {
  isDarkTheme,
  ThemeType,
  writeNewStyle,
}

export default theme
